<section id="register" class="page-wrapper">
  <div class="row auth-height full-height-vh m-0">
    <div class="col-12 d-flex align-items-center justify-content-center">
      <div class="card">
        <div class="card-header">
          <h2>Registration Form</h2>
        </div>
        <div class="card-content">
          <div class="card-body">
            <form [formGroup]="userRegisteration" (ngSubmit)="onSubmit(checkbox,consentForm)">
              <div class="row">
                <div class="col-md-6 col-12">
                  <div class="form-group row">
                    <label class="col-md-3 col-form-label" for="horizontal-form-1">First Name</label>
                    <div class="col-md-9">
                      <input type="text" class="form-control square" id="horizontal-form-1"
                             formControlName="firstName"
                      >
                      <p class="text-danger" *ngIf="submitted && rf.firstName.invalid">FirstName is required</p>
                    </div>
                  </div>
                </div>
                <div class="col-md-6 col-12">
                  <div class="form-group row">
                    <label class="col-md-3 col-form-label" for="horizontal-form-2">Middle Name</label>
                    <div class="col-md-9">
                      <input type="text" class="form-control square" id="horizontal-form-2"
                             formControlName="middleName">
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6 col-12">
                  <div class="form-group row">
                    <label class="col-md-3 col-form-label" for="horizontal-form-3">Last Name</label>
                    <div class="col-md-9">
                      <input type="text" class="form-control square" id="horizontal-form-3" formControlName="lastName">
                      <p class="text-danger" *ngIf="submitted && rf.lastName.invalid">LastName is required</p>
                    </div>
                  </div>
                </div>
                <div class="col-md-6 col-12">
                  <div class="form-group row">
                    <label class="col-md-3 col-form-label" for="horizontal-form-4">Email</label>
                    <div class="col-md-9">
                      <input type="text" class="form-control square" id="horizontal-form-4" formControlName="email">
                      <p class="text-danger" *ngIf="submitted && rf.email.invalid">Email is required</p>
                      <p class="text-danger" *ngIf="rf.email.hasError('email')">Invalid email</p>
                    </div>
                  </div>
                </div>

              </div>
              <div class="row">
                <div class="col-md-6 col-12">
                  <div class="form-group row">
                    <label class="col-md-3 col-form-label" for="horizontal-form-5">Phone Number</label>
                    <div class="col-md-9">
                      <input type="text" class="form-control square" id="horizontal-form-5" formControlName="number"
                             maxlength="10" minlength="8">
                      <p class="text-danger" *ngIf="submitted && rf.number.invalid">Phone number is required</p>
                      <p class="text-danger" *ngIf="rf.number.hasError('pattern')">Invalid Phone number</p>
                    </div>
                  </div>
                </div>
                <div class="col-md-6 col-12">
                  <div class="form-group row">
                    <label class="col-md-3 col-form-label" for="horizontal-form-5">Landline Number</label>
                    <div class="col-md-9">
                      <input type="text" class="form-control square" formControlName="landLineNumber"
                             maxlength="10" minlength="8">
                      <p class="text-danger" *ngIf="submitted && rf.landLineNumber.invalid">LandLine number is
                        required</p>
                      <p class="text-danger" *ngIf="rf.landLineNumber.hasError('pattern')">Invalid Land Line number</p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6 col-12">
                  <div class="form-group row">
                    <label class="col-md-3 col-form-label" for="horizontal-form-1">Password</label>
                    <div class="col-md-9">
                      <div class="input-group">
                        <input type="password" class="form-control square" #passsword formControlName="password">
                        <div class="input-group-prepend">
                          <span class="input-group-text cursor-pointer" (click)="showPassword(passsword,'password')"><i
                            [ngClass]="showpwd ? 'ft-eye' : 'ft-eye-off'"></i></span>
                        </div>
                      </div>
                      <p class="text-danger" *ngIf="submitted && rf.password.invalid">Password is required</p>
                    </div>
                  </div>
                </div>
                <div class="col-md-6 col-12">
                  <div class="form-group row">
                    <label class="col-md-3 col-form-label" for="horizontal-form-2">Confirm Password</label>
                    <div class="col-md-9">
                      <div class="input-group">
                        <input type="password" class="form-control square" #confirmpassword
                               formControlName="confirm_pwd">
                        <div class="input-group-prepend">
                          <span class="input-group-text cursor-pointer"
                                (click)="showPassword(confirmpassword,'confirm_password')"><i
                            [ngClass]="showConfirmPassword ? 'ft-eye' : 'ft-eye-off'"></i></span>
                        </div>
                      </div>
                      <p class="text-danger" *ngIf="submitted && rf.confirm_pwd.invalid">Confirm Password is
                        required</p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6 col-12">
                  <div class="form-group row">
                    <label class="col-md-3 col-form-label" for="horizontal-form-5">Date Of Birth</label>
                    <div class="col-md-9">
                      <div class="input-group">
                        <input class="form-control square" [minDate]="{year: 1901, month:1, day: 1}"
                               placeholder="dd-mm-yyyy" name="dp" ngbDatepicker
                               [(ngModel)]="model"
                               #d2="ngbDatepicker" [ngModelOptions]="{standalone: true}">
                        <div class="input-group-append">
                          <div class="input-group-text" (click)="d2.toggle()">
                            <i class="fa fa-calendar" style="cursor: pointer;"></i>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!--                  <p class="text-danger dateOfBirth" *ngIf="submitted && rf.dateOfBirth.invalid">Date of Birth is-->
                  <!--                    required</p>-->
                </div>
                <div class="col-md-6 col-12">
                  <div class="form-group row">
                    <label class="col-md-3 col-form-label" for="horizontal-form-2">Address Type</label>
                    <div class="col-md-9">
                      <select formControlName="addressType" id="" class="form-control square">
                        <option value="Home">Home</option>
                        <option value="Work">Work</option>
                        <option value="Others">Others</option>
                      </select>
                      <p class="text-danger" *ngIf="submitted && rf.addressType.invalid">AddressType is
                        required</p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6 col-12">
                  <div class="form-group row">
                    <label class="col-md-3 col-form-label" for="horizontal-form-2">Address</label>
                    <div class="col-md-9">
                      <input type="text" class="form-control square" formControlName="address">
                      <p class="text-danger" *ngIf="submitted && rf.address.invalid">Address is required</p>
                    </div>
                  </div>
                </div>
                <div class="col-md-6 col-12">
                  <div class="form-group row">
                    <label class="col-md-3 col-form-label" for="horizontal-form-2">Suburb</label>
                    <div class="col-md-9">
                      <input type="text" class="form-control square" formControlName="suburb">
                      <p class="text-danger" *ngIf="submitted && rf.suburb.invalid">Suburb is required</p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6 col-12">
                  <div class="form-group row">
                    <label class="col-md-3 col-form-label" for="horizontal-form-2">State</label>
                    <div class="col-md-9">
                      <ng-select formControlName="state" placeholder="Select State" [(ngModel)]="selectedState">
                        <ng-option *ngFor="let state of states" [value]="state">{{ state }}</ng-option>
                      </ng-select>
                      <p class="text-danger" *ngIf="submitted && rf.state.invalid">State is required</p>
                    </div>
                  </div>
                </div>
                <div class="col-md-6 col-12">
                  <div class="form-group row">
                    <label class="col-md-3 col-form-label" for="horizontal-form-2">Postcode</label>
                    <div class="col-md-9">
                      <input type="text" class="form-control square" formControlName="postcode" maxlength="4">
                      <p class="text-danger" *ngIf="submitted && rf.postcode.invalid">Postcode is required</p>
                      <p class="text-danger" *ngIf="userRegisteration.controls['postcode'].hasError('pattern')">Invalid
                        postcode</p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row mt-2">
                <div class="col-12 d-flex justify-content-center align-items-center">
                  <p class="checkbox text-center text-capitalize">
                    <input type="checkbox" id="acceptTerms" #checkbox>
                    <label for="acceptTerms"></label>I accept the
                    <a class="text-primary font-weight-bold text-capitalize" (click)="openModal(smallModal,'T&C')">terms & conditions</a> and
                     <a class="text-primary font-weight-bold text-capitalize" (click)="openModal(smallModal,'P&P')">privacy policy</a>
                  </p>
                </div>
              </div>
              <div class="row mt-1">
                <div class="col-12 d-flex justify-content-center align-items-center">
                  <p class="checkbox text-center text-capitalize">
                    <input type="checkbox" id="consentForm" #consentForm>
                    <label for="consentForm"></label>I wish to receive marketing material from the platform
                  </p>
                </div>
              </div>
              <div class="row mt-1">
                <div class="col-12 text-center">
                  <button type="submit" class="btn primary-btn mb-2"><i class="ft-check-square mr-1"></i>Sign Up
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<ng-template #smallModal let-modal let-d="dismiss">
  <div class="modal-header">
    <h4 class="modal-title">{{modalType === 'T&C' ? 'ScriptIT Terms & Conditions' : 'ScriptIT - Privacy Policy'}}</h4>
    <button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <app-terms-conditions *ngIf="modalType === 'T&C'"></app-terms-conditions>
    <app-privacy-policy *ngIf="modalType !== 'T&C'"></app-privacy-policy>
  </div>
</ng-template>

